import { useState, useEffect } from 'react';
import { Clock as ClockIcon } from 'lucide-react';

const Clock = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="clock-widget" data-testid="clock-widget">
      <ClockIcon size={20} />
      <div className="clock-time">
        <span className="time-display">{time.toLocaleTimeString('en-GB')}</span>
        <span className="date-display">{time.toLocaleDateString('en-GB', { 
          weekday: 'short', 
          day: 'numeric', 
          month: 'short' 
        })}</span>
      </div>
    </div>
  );
};

export default Clock;